<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="•-CH-TITLE-8-4-2015 ExtraBottomPMOD" id="_idParaDest-9"><a id="_idTextAnchor008"></a>2<br/>The Fierce Determination <br/>of a Grandmother</h1>
</div>
<div class="_idGenObjectStyleOverride-1">
<p class="•-CH-TITLE-DETAILS-8-4-2015 ExtraTopPMOD">Columbia Presbyterian Hospital </p>
<p class="•-CH-TITLE-DETAILS-8-4-2015">New York City</p>
<p class="•-CH-TITLE-DETAILS-8-4-2015">February 18, 2004</p>
<p class="•-VOICES-8-4-2015"><span class="Character-Style-3 CharOverride-12">◆ </span><span class="CharOverride-10">Suzanne Wright.</span> The day we got the official diagnosis for Christian, I was about as angry as I’ve ever been. After 2 full days of testing on our little guy, this whole team of specialists comes out and they say, it’s not this, it’s not that, it’s PDD-NOS.</p>
<p class="•-BODY-8-4-2015">I just looked at them. I mean, how dare they hide behind that lingo so?! I have to beg them to tell me what it is because they were afraid to say the word. But then finally they did. It’s autism, they said, and then very casually added, “It’s one in one hundred sixty-six.” Bob and I just looked at each other. </p>
<p class="•-BODY-8-4-2015">At that moment, autism became my enemy. It was like a monster in the room. Every time you looked at this beautiful little boy and then you knew what he was going through, all I could think was, I have to get this away from him. How am I going to get this thing solved? Where do I go? How do I get help? And there was nowhere to go, there was no grandmother that I could talk to, there was nobody, because nobody was talking about it. I was determined to muster every effort, to get every help, to go anywhere I needed to go to get some answers.</p>
<p class="•-BODY-8-4-2015">In the process, I ended up meeting many other families struggling with autism. They were so desperate for answers, for some kind of help, and they had nowhere to go. I thought, my God, how could this be? How could nobody be taking care of these kids?</p>
<p class="•-BODY-8-4-2015">And then in July Bob told me that this fellow Bernie Marcus wanted to come to the house and talk with us. <span class="Character-Style-3 CharOverride-12">◆</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_-_test-13.vue?4d66d8ec